/** Paths this microfrontend owns; everything else is a full document load into Vite Studio. */
export function isStudioLandingPagesPath(path: string): boolean {
  const pathname = path.split(/[?#]/, 1)[0] ?? path
  const withoutLocale = pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, '') || '/'
  return (
    withoutLocale === '/platform' ||
    withoutLocale.startsWith('/platform/') ||
    withoutLocale === '/desktop' ||
    withoutLocale.startsWith('/desktop/') ||
    withoutLocale === '/team' ||
    withoutLocale.startsWith('/team/') ||
    withoutLocale === '/moments' ||
    withoutLocale.startsWith('/moments/')
  )
}
